import styled from 'styled-components';
import { color } from 'theme';

export const StyledOptionLabel = styled.span`
    color: ${color('text.main')};
    font-weight: 900;
`;
